import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import DriverJobFilledAssignment from './DriverJobFilledAssignment';
import JobResourceOverrideDetails from './JobResourceOverrideDetails';

export default class DriverJobAssignment extends React.Component {
    getDropId = () => {
        const { jobIndex, assignmentIndex, day } = this.props;
        const dayInt = day.getDay();

        return `staff_${jobIndex}_${dayInt}_${assignmentIndex}`;
    };

    render() {
        const {
            day,
            group,
            job,
            assignmentIndex,
            onRemoveAssignment,
            onAssignmentFilterClicked,
        } = this.props;

        const dayInt = day.getDay();
        const dropId = this.getDropId();

        return (
            <div key={dropId} className="jobAssignment driver-job-assignment">
                <Droppable droppableId={dropId} style={{ transform: 'none' }}>
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ minHeight: '50px' }}
                            onClick={() => {
                                group &&
                                    onAssignmentFilterClicked &&
                                    onAssignmentFilterClicked({
                                        type: 'staff',
                                        label: group.name,
                                        assignableGroups:
                                            group.assignableGroups,
                                    });
                            }}
                        >
                            <label className="dropPlaceholder my-auto">
                                <FontAwesomeIcon
                                    icon={faUser}
                                    className="mr-1"
                                />
                            </label>
                            <div
                                className={cls('jobAssignmentDropTarget', {
                                    dragging: snapshot.isDraggingOver,
                                    show:
                                        !group.assignment ||
                                        !!snapshot.isDraggingOver,
                                })}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {!!group.assignment && (
                                    <DriverJobFilledAssignment
                                        key={`dfa_${dropId}`}
                                        job={job}
                                        group={group}
                                        assignmentIndex={assignmentIndex}
                                        onRemoveAssignment={onRemoveAssignment}
                                        dayInt={dayInt}
                                        {...this.props}
                                    />
                                )}
                                {!group.assignment && (
                                    <>
                                        <div className="dropPlaceholderWrapper">
                                            <div className="dropPlaceholderContent">
                                                <label className="dropPlaceholder mr-1">
                                                    {group.name}
                                                </label>
                                                {group.assignableGroups.map(
                                                    (g) => (
                                                        <span
                                                            title={g.groupName}
                                                            key={g.id}
                                                            className="badge badge-lg badge-secondary mr-1"
                                                        >
                                                            {g.groupName
                                                                .charAt(0)
                                                                .toUpperCase()}
                                                        </span>
                                                    )
                                                )}
                                            </div>
                                            <JobResourceOverrideDetails
                                                override={
                                                    group.jobResourceOverride
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
